import {
    type CreateDocumentPayload,
    type DocumentAsset,
    type DocumentMimeType,
    DocumentMimeTypes,
    type DocumentPayload,
    FileCategory,
    type FileData,
    FileIconMap,
    type MediaCreatePayload,
    type MediaPayload,
    MimeTypeCategoryMap,
    type PhotographData,
} from "@qendo/profile/files";
import type { ImagePickerAsset } from "expo-image-picker";
import type { QendoIconSet } from "~/components/QendoIcon";
import { filled } from "~/util";

export function isValidDocumentMimeType(mime?: string | null): mime is DocumentMimeType {
    return filled(mime) && DocumentMimeTypes.includes(mime as DocumentMimeType);
}

export function getFileCategory(mime?: string | null): FileCategory {
    return isValidDocumentMimeType(mime) ? MimeTypeCategoryMap[mime] : FileCategory.file;
}

export function getMimeIcon(mime?: string | null): QendoIconSet {
    return FileIconMap[getFileCategory(mime)];
}

export function isDocument(media?: FileData | null): media is FileData {
    return filled(media) && !isPhotograph(media);
}
export function isPhotograph(media?: FileData | null): media is PhotographData {
    return filled(media) && Object.hasOwn(media, "attachments");
}

export function isImage(media?: FileData | null): media is FileData<FileCategory.image> {
    return filled(media) && media.category === FileCategory.image;
}

export function isMediaCreatePayload(payload?: MediaPayload): payload is MediaCreatePayload {
    return filled(payload) && Object.hasOwn(payload, "asset");
}

export function isDocumentCreatePayload(payload?: DocumentPayload): payload is CreateDocumentPayload {
    return filled(payload) && Object.hasOwn(payload, "asset");
}

export function isImageAsset(asset: DocumentAsset): asset is ImagePickerAsset {
    return Object.hasOwn(asset, "width");
}

export function extractFilename(asset: DocumentAsset): string {
    return isImageAsset(asset) ? (asset.fileName ?? asset.uri.split("/").pop() ?? asset.uri) : asset.name;
}
